import React from "react";

import { useState, useEffect } from "react";
import "./BlockDetails.css";
import { useTranslation } from "react-i18next";
import Table from "../../../Components/UiComponents/Table/Table";

const BlockDetails = ({ blockdata }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredData = blockdata?.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  ) || [];

  return (
    <div className="premium-impact-list-container">
      {/* Optional Search */}
      <div className="d-flex justify-content-end mb-3">
        <div className="d-flex align-items-center" style={{ 
          background: "#fff", 
          border: "1px solid rgba(42,101,145,.15)", 
          borderRadius: "8px",
          padding: "2px 8px"
        }}>
          <input
            type="text"
            placeholder="Search block..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ 
              border: "none", 
              outline: "none", 
              fontSize: "0.75rem", 
              padding: "4px",
              width: "140px"
            }}
          />
          <svg viewBox="0 0 24 24" fill="none" width="14" height="14" stroke="#7A9BB0" strokeWidth="2">
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.3-4.3" />
          </svg>
        </div>
      </div>

      <div className="premium-impact-list">
        {filteredData.length > 0 ? (
          filteredData.map((block, i) => (
            <div key={i} className="avd-popup-row">
              <div className="avd-popup-row-left">
                <div className="avd-popup-row-num">{i + 1}</div>
                <svg viewBox="0 0 24 24" fill="none" width="14" height="14" stroke="#2A6591" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
                  <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
                  <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
                  <path d="M10 6h4" /><path d="M10 10h4" /><path d="M10 14h4" /><path d="M10 18h4" />
                </svg>
                <span>{block.name}</span>
              </div>
              {block?.count !== undefined && (
                <div className="avd-popup-row-badge">
                  {block.count.toLocaleString("en-IN")}
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="avd-popup-empty">
            <div className="mb-2">⚠️</div>
            <div>No matching blocks found</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlockDetails;
